import './ValidateEmail.css';
import { Button } from '../../ui';
import { useValidateEmail } from '../../../hooks';

export function ValidateEmail(props: {
   email: string;
   onSubmit: (verificationCode: string) => void;
   onCancel: () => void;
   isLoading: boolean;
   onResend: () => void;
   hideText?: boolean;
}) {
   const { onSubmit, onCancel, isLoading, email, onResend, hideText } = props;
   const { code, setCode, handlePaste, updateFocus, inputRef, setFocus, resetCode } = useValidateEmail();

   const submit = (e: any, data: { code: string }) => {
      e.preventDefault();
      onSubmit(data.code.trim());
   };

   const handleResend = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();
      resetCode();
      onResend();
   };

   return (
      <form
         className="email-validate flex flex-col gap-3 w-100"
         onSubmit={(e) => submit(e, { code: code.join('') })}>
         <div className="flex flex-col items-center gap-2">
            <div className="flex gap justify-center code-inputs">
               {code.map((char, index: number) => (
                  <input
                     key={index}
                     ref={(el) => (inputRef.current[index] = el)}
                     className="code-input"
                     value={char}
                     inputMode="numeric"
                     pattern="[0-9]*"
                     maxLength={1}
                     onChange={(e) => {
                        if (!/^[0-9]*$/.test(e.target.value)) return;

                        const value = e.target.value.slice(-1); // Ensure single character
                        const newCode = [...code];
                        newCode[index] = value;
                        setCode(newCode);

                        if (value) {
                           updateFocus(index, 'next');
                        }
                     }}
                     onPaste={(e) => {
                        if (index === 0) handlePaste(e);
                     }}
                     onKeyDown={(e) => {
                        if (e.key === 'Backspace') {
                           const newCode = [...code];
                           newCode[index] = '';
                           setCode(newCode);

                           if (index > 0 && !code[index]) {
                              updateFocus(index, 'prev');
                           }
                        } else if (e.key === 'Enter' && index === 5 && code.every((char) => char)) {
                           // Submit form when Enter is pressed on the last input and all fields are filled
                           e.preventDefault();
                           submit(e, { code: code.join('') });
                        }
                     }}
                     onFocus={() => {
                        setFocus((prevFocus) => {
                           const newFocus = Array(6).fill(false);
                           newFocus[index] = true;
                           return newFocus;
                        });
                     }}
                  />
               ))}
            </div>
            {!hideText && (
               <div className="flex flex-col gap items-center">
                  <div className="flex flex-col gap-1">
                     <span className="small gray text-center">
                        An email was sent to: <span className="white">{email}</span>
                     </span>
                     <p className="small gray">If you can't find the email, please check your spam folder.</p>
                  </div>

                  <Button
                     className="underline"
                     small
                     title="Resend Email"
                     type="transparent"
                     onClick={handleResend}
                     buttonType="button"
                  />
               </div>
            )}
         </div>

         <div className="flex flex-col gap-3 items-center">
            <Button
               loading={isLoading}
               disabled={code.some((char) => !char)}
               title="Verify And Continue"
               type="white-big"
               buttonType="submit"
            />
            <Button
               className=""
               type="transparent-big"
               title="Cancel"
               onClick={onCancel}
               buttonType="button"
            />
         </div>
      </form>
   );
}
